import { fetchRetry } from "../../assets/js/utils";

class BuchhaendlerEmpfehlungenBootstrap extends HTMLElement {

    connectedCallback() {
        this.removeAttribute('data-js');
        this.ladeindikator = this.querySelector('.ladeindikator');
        this.initMutationObserver();
        this.initIntersectionObserver();
    }

    initMutationObserver() {
        const config = {
            attributes: true,
            childList: true,
            subtree: true
        }
        const mutationObserver = new MutationObserver((mutationsList, observer) => {
            mutationsList.forEach(mutation => this.mutationObserverHandler(mutation, observer));
        });
        mutationObserver.observe(this, config);
    }

    async mutationObserverHandler(mutation, observer) {
        this.empfehlungenKomponente = mutation.target.querySelector('[component]');
        if (this.empfehlungenKomponente === null) return;
        this.bootstrapHoeheAktualisieren();
        observer.disconnect();
    }

    initIntersectionObserver() {
        const intersectionObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => this.intersectionObserverHandler(entry, observer));
        });
        intersectionObserver.observe(this);
    }

    async intersectionObserverHandler(entry, observer) {
        if (entry.isIntersecting) await this.initSlider(observer);
    }

    getCookie(name) {
        const value = "; " + document.cookie;
        const parts = value.split("; " + name + "=");
        if (parts.length === 2) {
            return parts.pop().split(";").shift();
        }
        return undefined;
    }

    async initSlider(observer) {
        try {
            let cookievalue = this.getCookie("KUNDE")
            if (typeof cookievalue !== 'undefined') {
                this.response = await fetchRetry(this.dataset.empfehlungenUri, {}, 3, 2000);
                this.html = await this.response.text();
                // Wenn die Response leer ist, entfernen wir das CustomElement aus dem DOM
                if (this.html.length === 0) {
                    this.parentNode.removeChild(this);
                    return;
                }
                if (this.html) {
                    this.render(this, this.html);
                }
            } else {
                // Kein Cookie gesetzt, wir entfernen den Bootstrap einfach aus dem DOM.
                this.parentNode.removeChild(this);
                return;
            }
        } catch (error) {
            console.error(error);
            this.querySelector(".malibu-fehler").removeAttribute("hidden");
            observer.disconnect();
        } finally {
            this.hideLadeindikator();
            observer.disconnect();
        }
    }

    render(target, html) {
        const range = document.createRange();
        range.setStart(target, 0);
        target.appendChild(
            range.createContextualFragment(html)
        );
    }

    bootstrapHoeheAktualisieren() {
        this.style.height = 'auto';
        this.style.maxHeight = 'none';
    }

    hideLadeindikator() {
        this.ladeindikator?.setAttribute("hidden", "");
    }
}

if (!customElements.get("buchhaendler-empfehlungen-bootstrap")) {
    customElements.define("buchhaendler-empfehlungen-bootstrap", BuchhaendlerEmpfehlungenBootstrap);
}
